import { render } from "./DialogBookChangeToUsed.vue?vue&type=template&id=071c7e78"
import script from "./DialogBookChangeToUsed.vue?vue&type=script&lang=js"
export * from "./DialogBookChangeToUsed.vue?vue&type=script&lang=js"
script.render = render

export default script